module.exports = __webpack_public_path__ + "img/weChatCode.1ddfb290.png";